export const environment = {
  production: true,
  apiURL : "https://persistent.neodigit.in/serverapp/api/",
  imageURL : "https://neologismtech.com/",
  projectTitle : "NeoDigit"
};
